export default __webpack_public_path__ + "static/media/placeholder_occhiali_white.761c5c31.svg";